import api from './api';

export const translationChatAPI = {
  // Lists bi-pepper's translation agents for the active brand (scoped via X-Brand)
  listAgents: () => api.get('/api/translation-chat/agents'),

  // Runs the translate -> bot -> translate pipeline for one message
  sendMessage: (data) => api.post('/api/translation-chat/message', data),

  // Records a rating (+ optional comment) for one translation direction
  saveFeedback: (data) => api.post('/api/translation-chat/feedback', data),
};

export default translationChatAPI;
